import {Injectable} from '@angular/core';
import {FilterService} from "./filterer/filter.service";
import {Dtos} from "../utils/dtos";
import {MenuItemRepository} from "../repositories/menu-item.repository";
import {BaseService} from "./common/base.service";
import {DataManipulationService} from "./common/data-manipulation.service";
import {ValidatorService} from "./common/validator.service";
import {MbColDefinition} from "../components/mb-datatable/models/mb-datatable.model";

@Injectable({
    providedIn: 'root'
})
export class MenuService extends BaseService<MenuItemRepository> {

    constructor(repo: MenuItemRepository, filterService: FilterService, dataManipulationService: DataManipulationService, validatorService: ValidatorService) {
        super(repo, filterService, dataManipulationService, validatorService);
        this.typeName = 'MenuItem';
    }

    getAll() {
        return super.getAll(Dtos.MENUITEM.MenuItemDTO);
    }


    protected defineModelSpecificColumns(extraInfo?: any): any[] {
        return [
            MbColDefinition.new('name', 'administration.menuItems.name'),
            MbColDefinition.new('uniqueName', 'administration.menuItems.uniqueName'),
            MbColDefinition.new('description', 'administration.menuItems.description'),
        ];
    }

    getLoggedInUserWithMenuItems() {
        return this.repo.getLoggedInUserWithMenuItems();
    }

    exportMenuItems() {
        const filter = this.filterService.filter(Dtos.MENUITEM.MenuItemWithoutBaseAttributesDTO).create();
        return this.repo.getAllByFilter(filter);
    }

    createFilteredSideBar(baseMenuItems: any[], loggedInUserMenuItems: any[]) {
        let actualMenuItemUniqueNames = [];
        loggedInUserMenuItems.forEach(item => {
            actualMenuItemUniqueNames.push(item.uniqueName);
        });
        baseMenuItems.forEach(route => {
            if (actualMenuItemUniqueNames.includes(route.title, 0)) {
                route.visible = true;
            }
            if (route.children != undefined && route.children.length > 0) {
                route.children = this.createFilteredSideBar(route.children, loggedInUserMenuItems);
            }
        });
        return baseMenuItems.filter(menuItem => menuItem);
    }

    enableFullSideBar(baseMenuItems: any[]) {
        baseMenuItems.forEach(route => {
            route.visible = true;
            if (route.children != undefined && route.children.length > 0) {
                route.children = this.enableFullSideBar(route.children);
            }
        });
        return baseMenuItems.filter(menuItem => menuItem);
    }

}

export class MenuItemModel {
    id: number;
    name: string;
    uniqueName: string;
    description: string;

    constructor() {
        this.id = 0;
        this.name = '';
        this.uniqueName = '';
        this.description = '';
    }
}
